"use client";

import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { setCookieByName } from "@/lib/cookies";

/** يكتب jobId واسم الشركة من الرابط إلى الكوكي قبل عرض الخطوات التالية (مهم لصفحة الفيديوهات وغيرها). */
export default function ApplyJobJobContextSync() {
  const location = useLocation();

  useLayoutEffect(() => {
    const params = new URLSearchParams(location.search);
    const jobId = params.get("jobId")?.trim();
    const company = params.get("company")?.trim();
    if (jobId) {
      void setCookieByName("JobId", jobId);
    }
    if (company) {
      void setCookieByName("SubmittedTo", company);
    }
  }, [location.search]);

  return null;
}
